import { Injectable } from "@angular/core";
import { API_URL } from "../config/general.config";
import { HttpClient } from "@angular/common/http";
import { Weather } from "../modules/go/model/weather.model";
import { Observable, switchMap } from "rxjs";
import { GeolocationService } from "./geolocation.service";

@Injectable({
  providedIn: 'root'
})
export class WeatherService {
  private weatherApi = `${API_URL}/weather`;

  constructor(
    private _http: HttpClient,
    private _geolocationService: GeolocationService
  ) { }

  getCurrentWeather(): Observable<Weather>{
    return this._geolocationService.getCurrentCoordinates()
    .pipe(
      switchMap(({longitude, latitude}) => this._http.get<Weather>(this.weatherApi, {params: {
        longitude,
        latitude
      }}))
    );
  }
}
